"use client";
export const dynamic = "force-dynamic";

import { Suspense, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import { useAuth } from "@/lib/auth/auth-context";
import { clearAuthRedirect, getAuthRedirect } from "@/lib/auth/store";

function LoginPageInner() {
  const params = useSearchParams();
  const router = useRouter();
  const { status } = useAuth();
  const redirect = params.get("next") ?? params.get("redirect");
  const authHref = redirect ? `/auth?redirect=${encodeURIComponent(redirect)}` : "/auth";

  useEffect(() => {
    if (status !== "authenticated") return;
    const target = redirect ?? getAuthRedirect() ?? "/dashboard";
    clearAuthRedirect();
    router.replace(target);
  }, [redirect, router, status]);

  if (status !== "unauthenticated") {
    return null;
  }

  return (
    <div
      dir="rtl"
      className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-main/5 to-secondary-main/5 p-4"
    >
      <div className="w-full max-w-md rounded-3xl border border-border bg-card p-8 shadow-lg">
        <h1 className="mb-6 text-center text-2xl font-black text-foreground">
          ورود به ترندی اسمارت
        </h1>
        <p className="mb-8 text-center text-sm text-muted-foreground">
          برای ورود از طریق سرویس‌های زیر اقدام کنید
        </p>
        <div className="space-y-3">
          <Link
            href={authHref}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-primary-main px-4 py-3 text-sm font-bold text-white transition hover:bg-primary-main/90"
          >
            <ArrowRight size={16} />
            ورود / ثبت‌نام
          </Link>
        </div>
      </div>
    </div>
  );
}

export default function LoginPage() {
  return (
    <Suspense fallback={null}>
      <LoginPageInner />
    </Suspense>
  );
}
